export default [
    {
        path: "/nomina/historial-empleados",
        name: "empleados-historial",
        component: () =>
            import(/* webpackChunkName: "plazasHistorial" */ "./index.vue"),
    }
];
